<span
  [matTooltip]="tooltip"
>
  {{ state.state | translate }}
</span>
